var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetamask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.966 3.07l-7.782 5.74 1.446-3.378 6.336-2.362z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05 3.07l7.677 5.793-1.364-3.43L3.051 3.07zM18.15 16.375l-2.066 3.153 4.423 1.217 1.263-4.3-3.62-.07zM2.23 16.446l1.258 4.299L7.9 19.528l-2.055-3.153-3.614.07z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.662 11.048l-1.228 1.854 4.375.207-.147-4.724-3 2.663zM16.33 11.054l-3.04-2.71-.106 4.765 4.375-.2-1.228-1.855zM7.898 19.527l2.652-1.275-2.28-1.771-.372 3.046zM13.45 18.252l2.633 1.276-.36-3.053-2.274 1.777z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.083 19.527l-2.634-1.275.213 1.712v.727l2.42-1.164zM7.898 19.527l2.457 1.181v-.726l.213-1.712-2.67 1.257z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.404 15.34l-2.197-.637 1.541-.715.656 1.353zM13.592 15.34l.643-1.352 1.56.715-2.203.638z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.899 19.528l.383-3.153-2.438.07 2.055 3.083zM15.71 16.375l.373 3.153 2.067-3.082-2.44-.071zM17.56 12.902l-4.376.207.407 2.238.644-1.352 1.559.714 1.765-1.807zM8.205 14.703l1.541-.714.644 1.352.42-2.232-4.376-.2 1.771 1.794z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.434 12.902l1.836 3.573-.065-1.772-1.771-1.8zM15.793 14.703l-.07 1.772 1.836-3.573-1.766 1.801zM10.81 13.11l-.408 2.237.526 2.646.112-3.49-.23-1.394zM13.183 13.11l-.212 1.393.106 3.496.514-2.652-.408-2.238z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.592 15.34l-.514 2.652.372.26 2.274-1.771.07-1.772-2.202.632zM8.207 14.703l.065 1.772 2.28 1.771.365-.26-.513-2.651-2.197-.632z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.639 20.69v-.726l-.201-.165h-2.953l-.195.165v.727L7.834 19.51l.862.702 1.742 1.181h2.952l1.772-1.18.85-.703-2.373 1.18z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 18.252l-.372-.26h-2.15l-.366.26-.224 1.712.195-.165h2.952l.201.165-.236-1.712z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.273 9.182l.65-3.16-.957-2.952-7.517 5.545 2.882 2.433 4.074 1.18.898-1.044-.39-.284.62-.59-.478-.366.626-.479-.408-.283zM2.07 6.023l.662 3.165-.425.313.631.478-.478.366.62.59-.39.284.898 1.045 4.074-1.18L10.55 8.65l-7.5-5.58-.98 2.953z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.405 12.236l-4.074-1.181 1.228 1.854-1.836 3.566 2.427-.03h3.62l-1.365-4.21zM7.663 11.049l-4.074 1.18L2.23 16.44h3.614l2.427.03-1.836-3.567 1.228-1.854zM13.184 13.11l.266-4.488 1.18-3.188H9.363l1.181 3.188.266 4.488.118 1.4v3.483h2.161V14.51l.095-1.4z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgMetamask;